import React from 'react';
import { Typography, Box, Tooltip } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

export const ProductCard = ({ productData }) => {
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const isGalaxyFold = useMediaQuery('(max-width:280px)');
    const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));

    // Format the data to handle both structures
    const productName = productData.name || productData.product_name;
    const productLink = productData.amazonAffiliateLink || productData.product_link;
    const productImage = productData.productImageAddress || productData.product_image_address;
    const productReason = productData.reason;
    const brandImage = productData.brandImageAddress || productData.brand_image_address

    return (
        <Box className='product-card' sx={{
            maxWidth: '100%',
            padding: '12px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
            display: 'flex',
            flexDirection: 'column',
            marginY: isLargeScreen ? '40px' : "0px",
            height : "140px"
        }}>
            <a href={productLink} target="_blank" rel="noopener noreferrer" style={{textDecoration: "none"}}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px',
                textDecoration : "none",

        
            }}>
                <Box sx={{ flex: 1, minWidth: 0, marginRight: '8px' }}>
                    <Typography
                        color="black"
                        variant="h6"
                        component="h2"
                        sx={{
                            fontWeight: 600,
                            fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '16px' : '16px',
                            marginBottom: '8px',
                            lineHeight: 1.2,
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 3,  // Limits text to 3 lines
                            overflow: 'hidden',
                        }}
                    >
                        {productName}
                    </Typography>
                    <Tooltip title={productReason} arrow>
                   <Typography
                    color="black"
                    variant="body2"
                    sx={{
                        fontWeight: 400,
                        fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '13px' : '14px',
                        marginBottom: '12px',
                        flexGrow: 1,
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        maxHeight: '3em',
                    }}
                >
                    {productReason}
                </Typography>
                </Tooltip>
                <img
                src={brandImage}
                alt="Genuine Health"
                style={{ width: '140px', height: 'auto', marginBottom: '8px' }}
            />
                </Box>
                <Box sx={{
                    width: '100px',
                    height: '100px',
                    flexShrink: 0,
                }}>
               
                        <img
                            src={productImage}
                            alt={productName}
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    
                </Box>
            </Box>
            </a>
        </Box>
    );
};